import { axios } from 'lib/axios';
import { toFormData } from './formData';
import { useQnaMutation } from './useQnaMutation';

const createNotification = (resource, id, values) =>
  axios.post(`/api/${resource}/${id}/qna/notifications`, toFormData(values));

export const useCreateNotification = (resource, id, onSuccess) =>
  useQnaMutation(resource, id, (values) => createNotification(resource, id, values), {
    successMessage: (values) =>
      values.publish ? 'Notification published' : 'Draft notification saved',
    onSuccess,
  });
